import React, {useCallback, useMemo} from 'react';
import {useDropzone} from 'react-dropzone';
import {packagingTokens as tk} from '@/theme/packagingTokens';

const baseStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    borderWidth: '2px',
    borderRadius: tk.radius.card,
    borderColor: tk.color.border,
    borderStyle: 'dashed',
    backgroundColor: tk.color.bg,
    color: tk.color.textTertiary,
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

export default function DropzoneImage(props: any) {
    const onDrop = useCallback((acceptedFiles: any) => {
        if (props.onDrop) {
            props.onDrop(acceptedFiles);
        }
    }, [props]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: { 'image': [".jpg", ".jpeg", ".png", ".gif"] } });

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);

    return (
        <div className="container">
            <div {...getRootProps({style})}>
                <input {...getInputProps()} />
                <p style={{textAlign: "center"}}>{ props.label === undefined ? props.t("upload_file") : props.label}</p>
            </div>
        </div>
    );
}
